import { useEffect, useRef } from "react";

import { useMessageBus } from "@jti/fe-message-bus";

export function useScrollDepth(
  onScrollDepthReached: () => void,
  isModalOpened: boolean,
  isScrollDepthEnabled?: boolean,
  eventType = "content_reached"
) {
  const reachedComponent = useRef(false);
  const messageBus = useMessageBus();
  // Latest-ref so callers can pass inline arrows without re-subscribing the
  // message bus or re-binding the window listener on every parent re-render.
  const onScrollDepthReachedRef = useRef(onScrollDepthReached);
  onScrollDepthReachedRef.current = onScrollDepthReached;

  useEffect(() => {
    const cartLoadedToken = messageBus.subscribe({
      channel: "cart.loaded",
      callback: () => {
        if (reachedComponent.current) {
          onScrollDepthReachedRef.current();
        }
      },
    });

    return () => {
      messageBus.unsubscribeToken(cartLoadedToken);
    };
  }, [messageBus]);

  useEffect(() => {
    if (!isScrollDepthEnabled || isModalOpened) return;

    const handleReachedEvent = () => {
      reachedComponent.current = true;
      onScrollDepthReachedRef.current();
    };

    window.addEventListener(eventType, handleReachedEvent);

    return () => {
      window.removeEventListener(eventType, handleReachedEvent);
    };
  }, [isScrollDepthEnabled, isModalOpened, eventType]);
}
